import(/* webpackMode: "eager" */ "/vercel/path0/app/(directory)/directory/page.tsx");
